<template>
  <b-form class="av-tooltip tooltip-label-bottom">
    <b-row>
      <b-col>
        <template v-if="isFindId">
          <b-form-group :label="$t('user.fullname')" class="has-float-label mb-4">
            <b-form-input type="text" v-model="$v.data.fullName.$model" :state="!$v.data.fullName.$error"/>
            <b-form-invalid-feedback v-if="!$v.data.fullName.required">{{ $t('user.required-name') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </template>

        <template v-else>
          <b-form-group :label="$t('user.username')" class="has-float-label mb-4">
            <b-form-input type="text" v-model="$v.data.username.$model" :state="!$v.data.username.$error"/>
            <b-form-invalid-feedback v-if="!$v.data.username.required">{{ $t('user.required-id') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group :label="$t('user.phoneNumber')" class="has-float-label mb-4">
          <b-form-input type="text" v-model="$v.data.phoneNumber.$model" :state="!$v.data.phoneNumber.$error"/>
          <b-form-invalid-feedback v-if="!$v.data.phoneNumber.required">{{ $t('user.required-phone') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>


    <div class="mt-3" v-if="otpFlag">
      <!--    <div class="mt-3">-->
      <b-row>
        <b-col>
          <b-form-group label="임시비밀번호" class="has-float-label mb-4">
            <b-form-input v-model="otp" type="text"/>
          </b-form-group>
        </b-col>
      </b-row>

      <!--    <b-row>-->
      <!--      <b-col>-->
      <!--        <b-form-group :label="$t('user.password')" class="has-float-label mb-4">-->
      <!--          <b-form-input type="text" v-model="$v.data.password.$model" :state="!$v.data.password.$error"/>-->
      <!--          <b-form-invalid-feedback v-if="!$v.data.password.required">{{ $t('user.required-password') }}-->
      <!--          </b-form-invalid-feedback>-->
      <!--        </b-form-group>-->
      <!--      </b-col>-->
      <!--    </b-row>-->

      <!--    <b-row>-->
      <!--      <b-col>-->
      <!--        <b-form-group :label="$t('user.passwordConfirm')" class="has-float-label mb-4">-->
      <!--          <b-form-input type="text" v-model="$v.data.passwordConfirm.$model" :state="!$v.data.passwordConfirm.$error"/>-->
      <!--          <b-form-invalid-feedback v-if="!$v.data.passwordConfirm.required">{{ $t('user.required-password') }}-->
      <!--          </b-form-invalid-feedback>-->
      <!--          <b-form-invalid-feedback v-else-if="!$v.data.passwordConfirm.sameAsPassword">-->
      <!--            {{$t('user.password-identical')}}-->
      <!--          </b-form-invalid-feedback>-->
      <!--        </b-form-group>-->
      <!--      </b-col>-->
      <!--    </b-row>-->
    </div>


    <div class="d-flex justify-content-between align-items-center">
      <b-button @click="goLogin" variant="outline-primary" size="" class="btn-shadow">{{ $t('button.back') }}
      </b-button>


      <b-button v-if="!otpFlag" @click="findPasswordOtp" variant="primary" size="lg">
        <span class="label">임시비밀번호 요청</span>
      </b-button>

      <b-button v-else @click="findPasswordLogin" variant="primary" size="lg">
        <span class="label">임시비밀번호 로그인</span>
      </b-button>

    </div>


  </b-form>
</template>
<script>

import {
  validationMixin
} from "vuelidate";
import {mapGetters} from "vuex";

const {
  required,
  maxLength,
  minLength,
  sameAs,
  email,
  helpers
} = require("vuelidate/lib/validators");

const passCheck = helpers.regex('passCheck', /^(?=.*[a-zA-Z]((?=.*\d)|(?=.*\W))).{8,16}$/);

export default {
  components: {},

  mixins: [validationMixin],
  validations: {
    data: {
      username: {
        required
      },
      fullName: {
        required,
      },
      phoneNumber: {
        required,
      },
      password: {
        required,
        // passCheck
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password')
      },
    }
  },
  props: ['data', '_mode'],

  mounted() {
    console.log(this._mode)
    if(this._mode === 'id') {
      this.isFindId = true
    }
  },

  data() {
    return {
      otp: null,
      otpFlag: false,
      isFindId: false
    }
  },
  computed: {
    ...mapGetters(['processing', 'loginError'])
  },
  methods: {
    goLogin() {
      this.$router.push(`/${this.$route.params.sitename}/user/login`)
    },

    findPasswordOtp() {

      this.$v.$touch()
      if(this.isFindId) {
        if(this.$v.data.fullName.$invalid === false && this.$v.data.phoneNumber.$invalid === false) {
          this.$emit('findFunction')
        }
      } else {
        if(this.$v.data.username.$invalid === false && this.$v.data.phoneNumber.$invalid === false) {
          this.$emit('findPasswordOtp', this.data.username, this.data.phoneNumber)
          this.otpFlag = true
        }

      }
    },

    findPasswordLogin() {
      this.$emit('findPasswordLogin', this.data.username, this.otp)
    }

  }
  , watch: {}
}
</script>
